import React, {Component} from 'react';
import I18n from 'lib/i18n/i18n';

class SellItemWizard extends Component{
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.step) {
            return null;
        }

        return (
            <div className={this.props.className}>
                <div className={"sell-item-wizard" + (this.props.step > 5 || this.props.hidden ? ' hide' : ' new-design')}>
                    <ul className={'steps'}>
                        <li className={`${this.props.step === 1 ? 'selected' : ''}`}><span>1</span></li>
                        <hr />
                        <li className={`${this.props.step === 2 ? 'selected' : ''}`}><span>2</span></li>
                        <hr />
                        <li className={`${this.props.step >= 3 ? 'selected' : ''}`}><span>3</span></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default SellItemWizard;
